const possibleValues = ['Offer Sheets', 'Award Sheets'];

export default possibleValues;
